import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { AlreadyAssessed } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class AlreadyAssessedModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title='Already Assessed'
        titleKey='moduleTitle.already_assessed'
      >
        <MaterialModal.Content>
          <AlreadyAssessed {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
